import Main from '../../../shared/types/enums/main';
import Rail from '../../../shared/classes/rail';
import Slider from '../../../shared/classes/slider';
import TMain from '../templates/main';
import moreContentObservable from '../../../shared/api/moreContent/moreContentObservable';
import useComplete from '../../../shared/components/utils/hooks/useComplete';
import { Observer, Subscription } from 'rxjs';
import { channelsSelector } from '../../../shared/store/slices/channels.slice';
import { eventsSelector } from '../../../shared/store/slices/events.slice';
import { planSelector } from '../../../shared/store/slices/plans.slice';
import { routerSelector } from '../../../shared/store/slices/router.slice';
import { useAppSelector } from '../../../shared/store/hooks';
import { userSelector } from '../../../shared/store/slices/user.slice';
import { useState, useEffect } from 'react';

function MoreContent() {
  const { channelsData } = useAppSelector(channelsSelector);
  const { eventsData } = useAppSelector(eventsSelector);
  const { data: planData } = useAppSelector(planSelector);
  const { initialized } = useAppSelector(userSelector);
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);

  const [complete, setComplete] = useComplete();
  const [rails, setRails] = useState<Rail[]>([]);
  const [sliders, setSliders] = useState<Slider[]>([]);

  useEffect(() => {
    if (complete) return;
    if (currentParams?.rails || currentParams?.sliders) {
      setComplete(true);
      return;
    }

    let subscription: Subscription;
    if (
      planData?.length &&
      channelsData?.length &&
      Object.keys(eventsData).length &&
      initialized
    ) {
      const initialObserver: Observer<{
        data: Slider[] | Rail[];
        type: Main;
      }> = {
        next: (val) => {
          if (val.type === Main.SLIDERS) {
            setSliders(val.data as Slider[]);
          } else if (val.type === Main.RAILS) {
            setRails(val.data as Rail[]);
          }
        },
        error: () => {
          console.error('Error recovering corners');
        },
        complete: () => {
          setComplete(true);
          return null;
        },
      };
      subscription = moreContentObservable().subscribe(
        initialObserver as Partial<Observer<unknown>>
      );
    }
    return () => {
      subscription?.unsubscribe();
    };
  }, [complete, initialized, channelsData, eventsData, planData]);

  return (
    <TMain
      complete={complete}
      rails={rails}
      hideBackground={true}
      sliders={sliders}
      startsInMenu={true}
      startsInSlider={true}
    />
  );
}

export default MoreContent;
